import _asyncToGenerator from "C:/GitLab-Runner/builds/VgMjNYji/0/billing/billingmalta/src/frontend/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { ApplicationRef, ElementRef, forwardRef } from '@angular/core';
import { NgModel, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { DataProperty, DataType, EntityAspect, EntityManager, EntityQuery, EntityType, NavigationProperty } from '@cime/breeze-client';
import { ControlSize } from '@common/classes/control-size';
import { AppFormComponent } from '@common/components/app-form/app-form.component';
import { ViewMode } from '@common/models/view-mode';
import { CodelistService } from '@common/services/codelist.service';
import { environment } from '@environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { FileSelectComponent } from '@progress/kendo-angular-upload';
import * as _ from 'lodash';
import * as i0 from "@angular/core";
import * as i1 from "@cime/breeze-client";
import * as i2 from "@angular/router";
import * as i3 from "@ngx-translate/core";
import * as i4 from "@common/services/codelist.service";
import * as i5 from "@angular/common";
import * as i6 from "@angular/forms";
import * as i7 from "@ng-bootstrap/ng-bootstrap";
import * as i8 from "@progress/kendo-angular-inputs";
import * as i9 from "@progress/kendo-angular-dropdowns";
import * as i10 from "@progress/kendo-angular-dateinputs";
import * as i11 from "@progress/kendo-angular-upload";
import * as i12 from "../checkbox/checkbox.component";
import * as i13 from "../upload-single-file.component";
import * as i14 from "../upload-multiple-files.component";
import * as i15 from "@common/components/app-form/app-form.component";
const _c0 = ["tooltip"];
const _c1 = ["textarea"];
const _c2 = function (a0, a1, a2) {
  return {
    "label-star": a0,
    "label-bg": a1,
    "disabled-bg": a2
  };
};
function AppControlComponent_label_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(3, _c2, !ctx_r0.isDisabled && ctx_r0.nullable === false, ctx_r0.type === ctx_r0.AppControlType.TextArea, ctx_r0.isDisabled))("for", ctx_r0.property);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.label, "\n");
  }
}
function AppControlComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
const _c3 = function (a0, a1) {
  return {
    "is-invalid": a0,
    prependPadding: a1
  };
};
function AppControlComponent_input_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 16, 17);
    i0.ɵɵlistener("ngModelChange", function AppControlComponent_input_3_Template_input_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const ctx_r17 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r17.value = $event);
    })("keyup.enter", function AppControlComponent_input_3_Template_input_keyup_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const ctx_r19 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r19.onKeyUp($event));
    })("focus", function AppControlComponent_input_3_Template_input_focus_0_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const ctx_r20 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r20.focusInHandler($event));
    })("blur", function AppControlComponent_input_3_Template_input_blur_0_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const ctx_r21 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r21.focusOutHandler($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c3, ctx_r2.errors.length > 0, !!ctx_r2.prepend))("ngModel", ctx_r2.value);
    i0.ɵɵattribute("readonly", "");
  }
}
const _c4 = function (a0, a1, a2) {
  return {
    "is-invalid": a0,
    "is-active": a1,
    prependPadding: a2
  };
};
function AppControlComponent_input_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 18, 17);
    i0.ɵɵlistener("ngModelChange", function AppControlComponent_input_4_Template_input_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r24);
      const ctx_r23 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r23.value = $event);
    })("keyup.enter", function AppControlComponent_input_4_Template_input_keyup_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r24);
      const ctx_r25 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r25.onKeyUp($event));
    })("keypress", function AppControlComponent_input_4_Template_input_keypress_0_listener($event) {
      i0.ɵɵrestoreView(_r24);
      const ctx_r26 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r26.onKeyPress($event));
    })("paste", function AppControlComponent_input_4_Template_input_paste_0_listener($event) {
      i0.ɵɵrestoreView(_r24);
      const ctx_r27 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r27.onKeyPress($event));
    })("focus", function AppControlComponent_input_4_Template_input_focus_0_listener($event) {
      i0.ɵɵrestoreView(_r24);
      const ctx_r28 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r28.focusInHandler($event));
    })("blur", function AppControlComponent_input_4_Template_input_blur_0_listener($event) {
      i0.ɵɵrestoreView(_r24);
      const ctx_r29 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r29.focusOutHandler($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(4, _c4, ctx_r3.errors.length > 0, !!ctx_r3.value, !!ctx_r3.prepend))("id", ctx_r3.property)("maxlength", ctx_r3.maxlength)("ngModel", ctx_r3.value);
  }
}
const _c5 = function (a0) {
  return {
    "is-invalid": a0
  };
};
function AppControlComponent_input_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 19, 17);
    i0.ɵɵlistener("ngModelChange", function AppControlComponent_input_5_Template_input_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r32);
      const ctx_r31 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r31.value = $event);
    })("keyup.enter", function AppControlComponent_input_5_Template_input_keyup_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r32);
      const ctx_r33 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r33.onKeyUp($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c5, ctx_r4.errors.length > 0))("ngModel", ctx_r4.value);
    i0.ɵɵattribute("readonly", ctx_r4.isDisabled ? "" : null);
  }
}
const _c6 = function (a0, a1) {
  return {
    "is-invalid": a0,
    disabled: a1
  };
};
function AppControlComponent_textarea_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "textarea", 20, 21);
    i0.ɵɵlistener("ngModelChange", function AppControlComponent_textarea_6_Template_textarea_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r37);
      const ctx_r36 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r36.value = $event);
    })("keyup.enter", function AppControlComponent_textarea_6_Template_textarea_keyup_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r37);
      const ctx_r38 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r38.onKeyUp($event));
    })("focus", function AppControlComponent_textarea_6_Template_textarea_focus_0_listener($event) {
      i0.ɵɵrestoreView(_r37);
      const ctx_r39 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r39.focusInHandler($event));
    })("blur", function AppControlComponent_textarea_6_Template_textarea_blur_0_listener($event) {
      i0.ɵɵrestoreView(_r37);
      const ctx_r40 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r40.focusOutHandler($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(4, _c6, ctx_r5.errors.length > 0, ctx_r5.isDisabled))("rows", ctx_r5.rows)("ngModel", ctx_r5.value);
    i0.ɵɵattribute("readonly", ctx_r5.isDisabled ? "" : null);
  }
}
const _c7 = function (a0, a1, a2) {
  return {
    "is-invalid": a0,
    disabled: a1,
    "is-read-only": a2
  };
};
function AppControlComponent_kendo_numerictextbox_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r43 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "kendo-numerictextbox", 22, 17);
    i0.ɵɵlistener("ngModelChange", function AppControlComponent_kendo_numerictextbox_7_Template_kendo_numerictextbox_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r43);
      const ctx_r42 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r42.value = $event);
    })("keyup.enter", function AppControlComponent_kendo_numerictextbox_7_Template_kendo_numerictextbox_keyup_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r43);
      const ctx_r44 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r44.onKeyUp($event));
    })("focus", function AppControlComponent_kendo_numerictextbox_7_Template_kendo_numerictextbox_focus_0_listener($event) {
      i0.ɵɵrestoreView(_r43);
      const ctx_r45 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r45.focusInHandler($event));
    })("blur", function AppControlComponent_kendo_numerictextbox_7_Template_kendo_numerictextbox_blur_0_listener($event) {
      i0.ɵɵrestoreView(_r43);
      const ctx_r46 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r46.focusOutHandler($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(8, _c7, ctx_r6.errors.length > 0, ctx_r6.isDisabled, ctx_r6.isDisabled))("maxlength", ctx_r6.maxlength)("format", ctx_r6.format)("min", ctx_r6.min || 0)("max", ctx_r6.max)("autoCorrect", true)("readonly", ctx_r6.isDisabled)("ngModel", ctx_r6.value);
  }
}
function AppControlComponent_kendo_combobox_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r49 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "kendo-combobox", 23, 17);
    i0.ɵɵlistener("ngModelChange", function AppControlComponent_kendo_combobox_8_Template_kendo_combobox_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r49);
      const ctx_r48 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r48.value = $event);
    })("keyup.enter", function AppControlComponent_kendo_combobox_8_Template_kendo_combobox_keyup_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r49);
      const ctx_r50 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r50.onKeyUp($event));
    })("focus", function AppControlComponent_kendo_combobox_8_Template_kendo_combobox_focus_0_listener($event) {
      i0.ɵɵrestoreView(_r49);
      const ctx_r51 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r51.focusInHandler($event));
    })("blur", function AppControlComponent_kendo_combobox_8_Template_kendo_combobox_blur_0_listener($event) {
      i0.ɵɵrestoreView(_r49);
      const ctx_r52 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r52.focusOutHandler($event));
    })("open", function AppControlComponent_kendo_combobox_8_Template_kendo_combobox_open_0_listener() {
      i0.ɵɵrestoreView(_r49);
      const ctx_r53 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r53.onDropdownOpen());
    })("filterChange", function AppControlComponent_kendo_combobox_8_Template_kendo_combobox_filterChange_0_listener($event) {
      i0.ɵɵrestoreView(_r49);
      const ctx_r54 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r54.applyFilterDebounced($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("title", ctx_r7.getTooltip(ctx_r7.value));
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(12, _c7, ctx_r7.errors.length > 0, ctx_r7.isDisabled, ctx_r7.isDisabled))("textField", ctx_r7.textField)("valueField", ctx_r7.valueField)("valuePrimitive", true)("data", ctx_r7.filteredOptions)("filterable", true)("clearButton", ctx_r7.nullable !== false)("readonly", ctx_r7.isDisabled)("loading", ctx_r7.isBusy)("popupSettings", ctx_r7.popupSettings)("ngModel", ctx_r7.value);
  }
}
function AppControlComponent_app_checkbox_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r56 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-checkbox", 24);
    i0.ɵɵlistener("ngModelChange", function AppControlComponent_app_checkbox_9_Template_app_checkbox_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r56);
      const ctx_r55 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r55.value = $event);
    })("keyup.enter", function AppControlComponent_app_checkbox_9_Template_app_checkbox_keyup_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r56);
      const ctx_r57 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r57.onKeyUp($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵproperty("label", ctx_r8.label)("property", ctx_r8.property)("size", ctx_r8.size)("disabled", ctx_r8.isDisabled)("click", ctx_r8.click)("ngModel", ctx_r8.value);
  }
}
function AppControlComponent_div_10_i_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r62 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "i", 28);
    i0.ɵɵlistener("click", function AppControlComponent_div_10_i_1_Template_i_click_0_listener() {
      i0.ɵɵrestoreView(_r62);
      const ctx_r61 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r61.dateValue = null);
    });
    i0.ɵɵelementEnd();
  }
}
const _c8 = function (a0, a1) {
  return {
    "is-invalid": a0,
    "is-read-only": a1
  };
};
function AppControlComponent_div_10_kendo_datepicker_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r66 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "kendo-datepicker", 29, 30);
    i0.ɵɵlistener("ngModelChange", function AppControlComponent_div_10_kendo_datepicker_2_Template_kendo_datepicker_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r66);
      const ctx_r65 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r65.dateValue = $event);
    })("keyup.enter", function AppControlComponent_div_10_kendo_datepicker_2_Template_kendo_datepicker_keyup_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r66);
      const ctx_r67 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r67.onKeyUp($event));
    })("focus", function AppControlComponent_div_10_kendo_datepicker_2_Template_kendo_datepicker_focus_0_listener($event) {
      i0.ɵɵrestoreView(_r66);
      const ctx_r68 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r68.focusInHandler($event));
    })("blur", function AppControlComponent_div_10_kendo_datepicker_2_Template_kendo_datepicker_blur_0_listener($event) {
      i0.ɵɵrestoreView(_r66);
      const ctx_r69 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r69.focusOutHandler($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r59 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c8, ctx_r59.errors.length > 0, ctx_r59.isDisabled))("readonly", ctx_r59.isDisabled)("ngModel", ctx_r59.dateValue);
  }
}
function AppControlComponent_div_10_kendo_datetimepicker_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r73 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "kendo-datetimepicker", 29, 31);
    i0.ɵɵlistener("ngModelChange", function AppControlComponent_div_10_kendo_datetimepicker_3_Template_kendo_datetimepicker_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r73);
      const ctx_r72 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r72.dateValue = $event);
    })("keyup.enter", function AppControlComponent_div_10_kendo_datetimepicker_3_Template_kendo_datetimepicker_keyup_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r73);
      const ctx_r74 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r74.onKeyUp($event));
    })("focus", function AppControlComponent_div_10_kendo_datetimepicker_3_Template_kendo_datetimepicker_focus_0_listener($event) {
      i0.ɵɵrestoreView(_r73);
      const ctx_r75 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r75.focusInHandler($event));
    })("blur", function AppControlComponent_div_10_kendo_datetimepicker_3_Template_kendo_datetimepicker_blur_0_listener($event) {
      i0.ɵɵrestoreView(_r73);
      const ctx_r76 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r76.focusOutHandler($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r60 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c8, ctx_r60.errors.length > 0, ctx_r60.isDisabled))("readonly", ctx_r60.isDisabled)("ngModel", ctx_r60.dateValue);
  }
}
function AppControlComponent_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵtemplate(1, AppControlComponent_div_10_i_1_Template, 1, 0, "i", 26);
    i0.ɵɵtemplate(2, AppControlComponent_div_10_kendo_datepicker_2_Template, 3, 6, "kendo-datepicker", 27);
    i0.ɵɵtemplate(3, AppControlComponent_div_10_kendo_datetimepicker_3_Template, 3, 6, "kendo-datetimepicker", 27);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.dateValue && !ctx_r9.isDisabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r9.time);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.time);
  }
}
function AppControlComponent_kendo_combobox_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r79 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "kendo-combobox", 32, 17);
    i0.ɵɵlistener("ngModelChange", function AppControlComponent_kendo_combobox_11_Template_kendo_combobox_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r79);
      const ctx_r78 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r78.value = $event);
    })("keyup.enter", function AppControlComponent_kendo_combobox_11_Template_kendo_combobox_keyup_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r79);
      const ctx_r80 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r80.onKeyUp($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("title", ctx_r10.getTooltip(ctx_r10.value));
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(8, _c6, ctx_r10.errors.length > 0, ctx_r10.isDisabled))("valuePrimitive", true)("data", ctx_r10.filteredOptions)("filterable", false)("disabled", ctx_r10.isDisabled)("clearButton", ctx_r10.nullable !== false)("ngModel", ctx_r10.value);
  }
}
function AppControlComponent_kendo_fileselect_12_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r84 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-upload-single-file", 35);
    i0.ɵɵlistener("removeFile", function AppControlComponent_kendo_fileselect_12_ng_template_2_Template_app_upload_single_file_removeFile_0_listener($event) {
      i0.ɵɵrestoreView(_r84);
      const ctx_r83 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r83.removeFile($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r82 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("file", ctx_r82.file)("disabled", ctx_r82.isDisabled);
  }
}
function AppControlComponent_kendo_fileselect_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r86 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "kendo-fileselect", 33, 17);
    i0.ɵɵlistener("ngModelChange", function AppControlComponent_kendo_fileselect_12_Template_kendo_fileselect_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r86);
      const ctx_r85 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r85.options = $event);
    })("clear", function AppControlComponent_kendo_fileselect_12_Template_kendo_fileselect_clear_0_listener($event) {
      i0.ɵɵrestoreView(_r86);
      const ctx_r87 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r87.clearFiles($event));
    })("select", function AppControlComponent_kendo_fileselect_12_Template_kendo_fileselect_select_0_listener($event) {
      i0.ɵɵrestoreView(_r86);
      const ctx_r88 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r88.addFiles($event));
    });
    i0.ɵɵtemplate(2, AppControlComponent_kendo_fileselect_12_ng_template_2_Template, 1, 2, "ng-template", 34);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(5, _c6, ctx_r11.errors.length > 0, ctx_r11.isDisabled))("hidden", ctx_r11.multi)("disabled", ctx_r11.isDisabled)("restrictions", ctx_r11.fileRestrictions)("ngModel", ctx_r11.options);
  }
}
function AppControlComponent_app_upload_multiple_files_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r91 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-upload-multiple-files", 36, 37);
    i0.ɵɵlistener("add", function AppControlComponent_app_upload_multiple_files_13_Template_app_upload_multiple_files_add_0_listener() {
      i0.ɵɵrestoreView(_r91);
      const ctx_r90 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r90.openFileSelect());
    })("removeFile", function AppControlComponent_app_upload_multiple_files_13_Template_app_upload_multiple_files_removeFile_0_listener($event) {
      i0.ɵɵrestoreView(_r91);
      const ctx_r92 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r92.removeFile($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵproperty("files", ctx_r12.getFiles(ctx_r12.value))("editMode", ctx_r12.editMode)("allowToEditFile", ctx_r12.allowToEditFile)("allowToDeleteFile", ctx_r12.allowToDeleteFile)("isInternalDisabled", ctx_r12.isInternalDisabled);
  }
}
const _c9 = function (a0) {
  return {
    "label-star": a0
  };
};
function AppControlComponent_div_14_label_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r93 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c9, !ctx_r93.isDisabled && ctx_r93.nullable === false))("for", ctx_r93.property);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r93.label, " ");
  }
}
function AppControlComponent_div_14_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 42);
    i0.ɵɵelement(1, "input", 43);
    i0.ɵɵelementStart(2, "label", 44);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const dataItem_r97 = ctx.$implicit;
    const ctx_r95 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("checked", ctx_r95.isItemSelected(dataItem_r97.value));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(dataItem_r97.label);
  }
}
function AppControlComponent_div_14_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 45);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r96 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" (", ctx_r96.multiselectValue.length, ") ");
  }
}
function AppControlComponent_div_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r99 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 38);
    i0.ɵɵtemplate(1, AppControlComponent_div_14_label_1_Template, 2, 5, "label", 0);
    i0.ɵɵelementStart(2, "kendo-multiselect", 39, 17);
    i0.ɵɵlistener("ngModelChange", function AppControlComponent_div_14_Template_kendo_multiselect_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r99);
      const ctx_r98 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r98.multiselectValue = $event);
    })("keyup.enter", function AppControlComponent_div_14_Template_kendo_multiselect_keyup_enter_2_listener($event) {
      i0.ɵɵrestoreView(_r99);
      const ctx_r100 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r100.onKeyUp($event));
    })("open", function AppControlComponent_div_14_Template_kendo_multiselect_open_2_listener() {
      i0.ɵɵrestoreView(_r99);
      const ctx_r101 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r101.onDropdownOpen());
    })("mouseenter", function AppControlComponent_div_14_Template_kendo_multiselect_mouseenter_2_listener() {
      i0.ɵɵrestoreView(_r99);
      const ctx_r102 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r102.isMouseenter = true);
    })("mouseleave", function AppControlComponent_div_14_Template_kendo_multiselect_mouseleave_2_listener() {
      i0.ɵɵrestoreView(_r99);
      const ctx_r103 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r103.isMouseenter = false);
    })("focus", function AppControlComponent_div_14_Template_kendo_multiselect_focus_2_listener($event) {
      i0.ɵɵrestoreView(_r99);
      const ctx_r104 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r104.focusInHandler($event));
    })("blur", function AppControlComponent_div_14_Template_kendo_multiselect_blur_2_listener($event) {
      i0.ɵɵrestoreView(_r99);
      const ctx_r105 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r105.focusOutHandler($event));
    })("filterChange", function AppControlComponent_div_14_Template_kendo_multiselect_filterChange_2_listener($event) {
      i0.ɵɵrestoreView(_r99);
      const ctx_r106 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r106.applyFilterDebounced($event));
    });
    i0.ɵɵtemplate(4, AppControlComponent_div_14_ng_template_4_Template, 4, 2, "ng-template", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, AppControlComponent_div_14_span_5_Template, 2, 1, "span", 41);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.label);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("title", ctx_r13.getTooltip(ctx_r13.value));
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(14, _c8, ctx_r13.errors.length > 0, ctx_r13.isDisabled))("textField", ctx_r13.textField)("valueField", ctx_r13.valueField)("valuePrimitive", true)("data", ctx_r13.filteredOptions)("filterable", true)("loading", ctx_r13.isBusy)("clearButton", ctx_r13.nullable !== false)("readonly", ctx_r13.isDisabled)("popupSettings", ctx_r13.popupSettings)("ngModel", ctx_r13.multiselectValue);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !(ctx_r13.isBusy || ctx_r13.isMouseenter) && (ctx_r13.multiselectValue == null ? null : ctx_r13.multiselectValue.length) > 0);
  }
}
function AppControlComponent_ng_template_16_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 47)(1, "span", 48);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r107 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r107.prepend, " ");
  }
}
function AppControlComponent_ng_template_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, AppControlComponent_ng_template_16_div_0_Template, 3, 1, "div", 46);
  }
  if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r15.prepend && ctx_r15.hasValue);
  }
}
const _c10 = [[["", 8, "input-group-prepend"]], [["", 8, "input-group-append"]]];
const _c11 = function (a0, a1) {
  return [a0, a1];
};
const _c12 = [".input-group-prepend", ".input-group-append"];
export var AppControlType;
(function (AppControlType) {
  AppControlType["String"] = "string";
  AppControlType["TextArea"] = "textarea";
  AppControlType["Boolean"] = "boolean";
  AppControlType["DateTime"] = "datetime";
  AppControlType["Number"] = "number";
  AppControlType["Array"] = "array";
  AppControlType["Password"] = "password";
  AppControlType["CodeList"] = "codelist";
  AppControlType["File"] = "file";
  AppControlType["YesNo"] = "yesno";
  AppControlType["Select"] = "select";
})(AppControlType || (AppControlType = {}));
// TODO: localize
const yesNoValues = [{
  value: true,
  text: 'Yes'
}, {
  value: false,
  text: 'No'
}];
const defaultSelectLabel = item => `${item.customText || (item.code || item.id) + (item.name ? ` - ${item.name}` : '')}`;
// TODO:  - split codelist component
//        - remote filtering
export class AppControlComponent {
  set maxFileSize(value) {
    this.fileRestrictions.maxFileSize = value || this.fileRestrictions.maxFileSize;
  }
  set allowedExtensions(value) {
    this.fileRestrictions.allowedExtensions = value || this.fileRestrictions.allowedExtensions;
  }
  get maxFileSize() {
    return this.fileRestrictions.maxFileSize;
  }
  get allowedExtensions() {
    return this.fileRestrictions.allowedExtensions;
  }
  set tooltip(value) {
    this._tooltip = value;
    if (value) {
      this.showValidationErrors();
    }
  }
  get tooltip() {
    return this._tooltip;
  }
  get isEntity() {
    return this.entity && this.entity.entityAspect instanceof EntityAspect;
  }
  get navigationProperty() {
    if (!this.isEntity) {
      return this.property;
    }
    if (!this.property || !this.entity) {
      return this.property;
    }
    if (this.entity.entityType.getProperty(`${this.property}Id`)) {
      return `${this.property}Id`;
    }
    return this.property;
  }
  get breezePropertyToAppControlType() {
    if (!this.isEntity) {
      return null;
    }
    const property = this.getBreezeProperty();
    if (this.isCodeList) {
      return AppControlType.CodeList;
    }
    this.dataType = property.dataType;
    switch (property.dataType) {
      case DataType.Boolean:
        return this.nullable ? AppControlType.YesNo : AppControlType.Boolean;
      case DataType.DateTime:
        this.format = `dd/MM/yyyy${this.time ? ' hh:MM' : ''}`;
        return AppControlType.DateTime;
      case DataType.Int16:
      case DataType.Int32:
      case DataType.Int64:
      case DataType.Decimal:
      case DataType.Single:
      case DataType.Double:
        return AppControlType.Number;
      case DataType.String:
        return AppControlType.String;
      case DataType.DateTimeOffset:
      case DataType.Time:
      case DataType.Undefined:
      case DataType.Binary:
      case DataType.Guid:
      case DataType.Byte:
      default:
        // tslint:disable-next-line:max-line-length
        throw new Error(`Unsupported [type = '${property.breezeType}'] on [modelPath = '${this.modelPath}'] and [property = '${this.property}']`);
    }
  }
  set value(value) {
    // this value is updated by programmatic changes if( val !== undefined && this.val !== val){
    this.val = value;
    this.onChange(value);
    this.onTouch(value);
    if (this.form) {
      this.form.onChange(this, value);
    }
  }
  get value() {
    return this.val;
  }
  get dateValue() {
    if (_.isDate(this.val)) {
      return this.val;
    }
    if (_.isString(this.val)) {
      const date = new Date(this.val);
      if (!date || !this._date || date.getTime() !== this._date.getTime()) {
        this._date = date;
      }
      return this._date;
    }
    return this.val;
  }
  set dateValue(value) {
    this._date = value;
    this.value = _.isDate(value) ? value.toISOString() : value;
  }
  get multiselectValue() {
    if (this.childEntityName && this.value) {
      const codes = this.value.map(x => x[this.fkName]);
      if (_.xor(codes, this._multiselectValue).length) {
        this._multiselectValue = codes;
      }
      return this._multiselectValue;
    }
    return this.value;
  }
  set multiselectValue(value) {
    if (this.childEntityName) {
      this._multiselectValue = value;
      _.each(value, id => {
        if (!id) {
          return;
        }
        const elementPresent = _.find(this.entity[this.property], x => x[this.fkName] === id);
        if (!elementPresent) {
          const newEntity = this.entity.entityAspect.entityManager.createEntity(this.childEntityName);
          newEntity[this.fkName] = id;
          this.entity[this.property].push(newEntity);
        }
      });
      _.each(_.clone(this.entity[this.property]), x => {
        const elementPresent = _.find(value, id => x[this.fkName] === id);
        if (!elementPresent) {
          x.entityAspect.setDeleted();
        }
      });
      this.onChange(this.value);
      this.onTouch(this.value);
      this.form?.onChange(this, this.value);
    } else {
      this.value = value;
    }
  }
  constructor(entityManager, applicationRef, activatedRoute, translateService, elementRef, codelistService, form) {
    this.entityManager = entityManager;
    this.applicationRef = applicationRef;
    this.activatedRoute = activatedRoute;
    this.translateService = translateService;
    this.elementRef = elementRef;
    this.codelistService = codelistService;
    this.form = form;
    this.AppControlType = AppControlType;
    this.errors = [];
    this.filteredOptions = [];
    this.fileRestrictions = {
      maxFileSize: environment.settings.appControl.fileMaxSize,
      allowedExtensions: environment.settings.appControl.fileAllowedExtensions
    };
    this.showTooltip = environment.settings.validation.errors.showTooltip;
    this.showFeedback = environment.settings.validation.errors.showFeedback;
    this.isBusy = false;
    this.applyFilterDebounced = _.debounce(this.applyFilter, 200);
    this.options = [];
    this.codelistTake = environment.settings.appControl.codelist.take;
    this.selectLabel = defaultSelectLabel;
    this.size = environment.settings.appControl.size;
    this.multi = environment.settings.appControl.multi;
    this.time = environment.settings.appControl.time;
    this.hasValue = false;
    this.margin = true;
    this.blur = _.noop;
    this.nullable = null;
    this.textField = 'label';
    this.valueField = 'value';
    this.popupSettings = environment.settings.appControl.dropdown.popupSettings;
    this.isInternalDisabled = false;
    this.tooltipPlacement = 'bottom';
    this.onChange = _.noop;
    this.onTouch = _.noop;
    this.allowToEditFile = file => true;
    this.allowToDeleteFile = file => true;
    // entityManager is a global instance
    // if app-component logic is changed so that navigation properties are set instead of synthetic
    // then an empty copy should be created (or the one from entity.entityAspect.entityManager should be used
  }

  setNumericFormat() {
    if (_.isString(this.format)) {
      return;
    }
    switch (this.dataType) {
      case DataType.Int16:
      case DataType.Int32:
      case DataType.Int64:
        this.format = 'n0';
        break;
      default:
        this.format = environment.settings.appControl.format;
        break;
    }
  }
  ngOnInit() {
    this.maybeApplyActive();
    if (this.isEntity) {
      this.type = this.type ? this.type : this.breezePropertyToAppControlType;
      this.nullable = this.getBreezePropertyNullability();
      this.fillValidationErrors();
    }
    if (this.type === AppControlType.Number) {
      this.setNumericFormat();
    }
    if (!this.type) {
      this.type = AppControlType.String;
    }
    // this._syntheticProperty = this.navigationProperty;
    this.setDisabledMode();
    if (this.form) {
      this.form.registerAppControl(this);
    }
    if (this.initialValue && !this.value) {
      // Execute after content has been checked
      setTimeout(() => this.value = this.initialValue);
    }
  }
  setDisabledMode() {
    if (this.isDisabled === undefined && this.activatedRoute.snapshot.data && this.activatedRoute.snapshot.data.mode === ViewMode.view) {
      this.isDisabled = true;
    } else if (this.isDisabled === undefined && this.editMode === undefined) {
      // workaround to handle modal window
      let childRoot = _.first(this.activatedRoute.children);
      while (childRoot) {
        if (childRoot.snapshot.data.mode) {
          this.isDisabled = childRoot.snapshot.data.mode === ViewMode.view;
        }
        childRoot = _.first(childRoot.children);
      }
    } else if (this.editMode !== undefined) {
      this.isDisabled = !this.editMode;
    }
  }
  maybeApplyActive() {
    this.hasValue = ![null, undefined].includes(this.value) && this.value?.length !== 0;
  }
  ngOnDestroy() {
    if (this._subscription) {
      this.entity.entityAspect.validationErrorsChanged.unsubscribe(this._subscription);
    }
    if (this.form) {
      this.form.unregisterAppControl(this);
    }
  }
  ngOnChanges(changes) {
    var _this = this;
    return _asyncToGenerator(function* () {
      if (changes?.ngModel && (changes.ngModel.firstChange || !changes.ngModel.previousValue || changes.ngModel.previousValue?.length === 0)) {
        _this.writeValue(changes.ngModel.currentValue);
      }
      if (_.isArray(_this.value) && _this.isEntity && _this.value.navigationProperty && _this.codelist) {
        _this.childEntityName = _this.value.navigationProperty.entityType.shortName;
        const idProperty = _.find(_this.value.navigationProperty.entityType.navigationProperties, x => x.entityType.shortName === _this.codelist);
        _this.fkName = `${idProperty.name}Id`;
      }
      if (changes?.entity && _this.isEntity) {
        if (_this._subscription) {
          _this.entity.entityAspect.validationErrorsChanged.unsubscribe(_this._subscription);
        }
        _this._subscription = _this.entity.entityAspect.validationErrorsChanged.subscribe(() => {
          _this.fillValidationErrors();
          _this.showValidationErrors();
        });
      }
      const currentValue = changes.ngModel?.currentValue;
      if (_this.isEntity && !_this.type) {
        _this.type = _this.breezePropertyToAppControlType;
      }
      if (changes && (changes.entity || changes.codelist)) {
        const initialValue = changes.initialValue?.currentValue;
        _this.applyFilter(null, initialValue || currentValue, true);
      }
      if (changes && _this.type === AppControlType.YesNo) {
        _this.filteredOptions = yesNoValues;
      }
      if (currentValue && changes?.entity && _this.type === AppControlType.File) {
        _this.fetchFiles();
      }
      if (changes?.options && [AppControlType.CodeList, AppControlType.Select].includes(_this.type)) {
        _this.filteredOptions = _this.options;
      }
      if (!currentValue && _this.type === AppControlType.File && !_this.multi && _this.options) {
        _this.file = null;
        _this.options = []; // Remove the empty li tag
      }

      if (_this.codelist && !_this.multi && !!currentValue && !_this.filteredOptions.map(o => o.value).includes(currentValue)) {
        const item = (yield _this.codelistService.getCodelist({
          name: _this.codelist,
          selectedIds: [currentValue],
          filter: '',
          take: 1,
          useCache: false
        }))[0];
        _this.filteredOptions = [..._this.filteredOptions, {
          label: _this.selectLabel(item),
          value: item.id
        }];
      }
      _this.maybeApplyActive();
    })();
  }
  getBreezeProperty() {
    const property = this.entity.entityType.getProperty(this.navigationProperty);
    if (!property) {
      throw new Error(`[Property = '${this.property}'] does not exists on [modelType = '${this.entity.entityType.shortName}']`);
    }
    return property;
  }
  getBreezePropertyNullability() {
    const property = this.getBreezeProperty();
    return property instanceof DataProperty ? this.nullable = property.isNullable : null;
  }
  fillValidationErrors() {
    const navigationProperty = this.getNavigationProperty()?.name;
    const validationErrors = _.filter(this.entity.entityAspect.getValidationErrors(), validatorError => !!validatorError.propertyName && validatorError.propertyName === navigationProperty || validatorError.propertyName === this.property);
    this.errors = validationErrors;
  }
  showValidationErrors() {
    if (this.errors.length > 0 && !this.disableTooltip) {
      this.tooltip.ngbTooltip = _.map(this.errors, x => x.errorMessage).join('\n');
      if (this.showTooltip) {
        this.tooltip.open();
      }
    } else {
      this.tooltip.ngbTooltip = null;
      this.tooltip.close();
    }
  }
  fetchFiles() {
    const navigationProperty = this.getNavigationProperty();
    if (navigationProperty) {
      if (!navigationProperty.isScalar) {
        this.multi = true;
        this.collectionRowEntityType = navigationProperty.entityType;
      } else {
        this.multi = false;
      }
    }
    // Retrieve attachments
    const ids = [];
    if (this.multi) {
      _.each(this.value, entity => {
        if (!entity.attachment) {
          ids.push(entity.attachmentId);
        }
      });
    } else if (navigationProperty) {
      const id = this.entity[this.navigationProperty];
      if (id) {
        if (id > 0) {
          ids.push(id);
        } else {
          this.options = [{
            name: ''
          }]; // Hack in order to have a li tag generated
          this.file = this.entity[navigationProperty.name];
          return;
        }
      }
    }
    if (this.multi || ids.length) {
      this.options = [{
        name: ''
      }]; // Hack in order to have a li tag generated
    }

    if (!ids.length) {
      return;
    }
    const query = new EntityQuery('Attachments').withParameters({
      $method: 'POST',
      $data: {
        ids
      }
    });
    return this.entity.entityAspect.entityManager.executeQuery(query).then(data => {
      if (!this.multi) {
        this.file = data.results[0];
      }
      this.applicationRef.tick();
    });
  }
  getNavigationProperty() {
    if (!this.isEntity) {
      return null;
    }
    const property = this.entity.entityType.getProperty(this.property);
    return property instanceof NavigationProperty ? property : _.find(this.entity.entityType.foreignKeyProperties, fk => fk.name === this.property)?.relatedNavigationProperty;
  }
  applyFilter(search = null, value = this.value, useCache = false) {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      if (_this2.fetch) {
        _this2.fetch(search, value).then(data => {
          if (_.isFunction(_this2.filter)) {
            data = data.filter(x => _this2.filter(x, search));
          }
          _this2.filteredOptions = _this2.options = _this2.filteredOptions = data;
        });
        return;
      }
      if (!_this2.isCodeList) {
        _this2.filteredOptions = _this2.options?.filter((x, i) => x.value === value || x.label?.toLowerCase().includes(search?.toLowerCase()) || _this2.filter?.(x, search) === true);
        return;
      }
      if (!_this2.codelist) {
        const property = _this2.entity.entityType.getProperty(_this2.property);
        _this2.codelist = property.entityType instanceof EntityType ? property.entityType.shortName : _.find(_this2.entity.entityType.foreignKeyProperties, fk => fk.name === _this2.property).relatedNavigationProperty.entityType.shortName;
      }
      let selectedIds = _.isArray(value) ? value : value ? [value] : null;
      if (selectedIds && _this2.childEntityName) {
        selectedIds = selectedIds.map(x => x[_this2.fkName]);
      }
      _this2.isBusy = true;
      try {
        let data = yield _this2.codelistService.getCodelist({
          name: _this2.codelist,
          selectedIds,
          filter: search,
          take: _this2.codelistTake,
          useCache
        });
        if (!data) return;
        if (_.isFunction(_this2.filter)) {
          data = data.filter(x => _this2.filter(x, search));
        }
        _this2.options = data.map(x => ({
          label: _this2.selectLabel(x),
          value: x.id
        }));
        _this2.filteredOptions = _.uniq(_this2.options.filter((x, i) => x.value === value || i < _this2.codelistTake + (selectedIds?.length || 0)));
        _this2.isBusy = false;
        _this2.applicationRef.tick();
      } finally {
        _this2.isBusy = false;
      }
    })();
  }
  writeValue(obj) {
    this.val = obj;
  }
  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn) {
    this.onTouch = fn;
  }
  setDisabledState(isDisabled) {
    // this.isDisabled = isDisabled;
  }
  get isCodeList() {
    if (this.type && this.type !== AppControlType.CodeList) {
      // to avoid file and select
      return false;
    }
    if (this.codelist || this.navigationProperty !== this.property) {
      return true;
    }
    if (this.isEntity && _.some(this.entity.entityType.foreignKeyProperties, fk => fk.name === this.property)) {
      return true;
    }
    return false;
  }
  isItemSelected(val) {
    if (this.childEntityName) {
      const selectedValues = _.map(this.entity[this.property], x => x[this.fkName]);
      return selectedValues.some(x => x === val);
    }
    return this.value?.some(x => x === val);
  }
  onDropdownOpen() {
    if (this.fetchOnOpen || this.fetch && (!this.options || this.options.length <= 1)) {
      this.applyFilter(null, this.value, true);
      return;
    }
    this.filteredOptions = this.options.filter((x, i) => x.value === this.value || i < this.codelistTake);
  }
  getTooltip(value) {
    if (!value) {
      return undefined;
    }
    let values = value;
    if (this.childEntityName) {
      values = _.map(this.entity[this.property], x => x[this.fkName]);
    }
    if (!_.isArray(values)) {
      values = [values];
    }
    const labels = _.map(_.filter(this.options, x => values.includes(x.value)), x => x.label);
    return labels?.join('\n');
  }
  addFiles(event) {
    if (!event.files) return;
    if (this.tooltip.ngbTooltip) {
      this.tooltip.ngbTooltip = null;
      this.tooltip.close();
    }
    if (_.some(event.files, file => file.validationErrors && file.validationErrors.length > 0)) {
      const errors = _.chain(event.files).filter(file => file.validationErrors && file.validationErrors.length > 0).map(file => file.validationErrors).flatten().uniq().map(msg => this.translateService.instant(msg)).value();
      this.tooltip.ngbTooltip = errors.join('\n');
      this.tooltip.open();
      event.preventDefault();
      return;
    }
    if (this.multi) {
      event.preventDefault(); // Avoid adding another li tag
      if (!_.isArray(this.value)) {
        this.value = [];
      }
      _.each(event.files, (file, i) => {
        this.loadFile(file, content => {
          file.content = content;
          if (this.isEntity) {
            const entityManager = this.entity.entityAspect.entityManager;
            const row = entityManager.createEntity(this.collectionRowEntityType);
            row.attachment = entityManager.createEntity('Attachment', {
              content,
              name: file.name
            });
            this.val.push(row);
          } else {
            this.value = this.value.slice(); // Copy array in order to update the grid
            this.value.push({
              name: file.name,
              content
            });
          }
        });
      });
    } else {
      const file = event.files[0];
      this.loadFile(file, content => {
        file.content = content;
        if (this.file) {
          event.preventDefault(); // Avoid adding another li tag
        }

        if (this.isEntity) {
          this.entity[this.getNavigationProperty().name] = this.file = this.entity.entityAspect.entityManager.createEntity('Attachment', {
            content,
            name: file.name
          });
        } else {
          this.value = this.file = {
            content,
            name: file.name
          };
        }
      });
    }
  }
  openFileSelect() {
    this.setDisabledMode();
    setTimeout(() => {
      this.kendoFileSelect.fileSelectInput.nativeElement.click();
    });
  }
  getFiles(value) {
    return _.map(value, v => v.attachment || v);
  }
  removeFile(attachment) {
    if (this.multi) {
      if (this.isEntity) {
        const parent = _.filter(this.value, row => row.attachmentId === attachment.dataItem.id)[0];
        attachment.dataItem.entityAspect.setDeleted();
        parent.entityAspect.setDeleted();
      } else {
        this.value.splice(this.val.indexOf(attachment), 1);
        this.value = this.value.slice(); // Copy array in order to update the grid
      }

      return;
    }
    if (this.isEntity) {
      attachment.dataItem.entityAspect.setDeleted();
    }
    this.value = null;
    this.options = []; // Remove the empty li tag
  }

  clearFiles(event) {
    // BUG: Bug in FileSelect component which throws for single file
    // TODO: implement when the bug is fixed
  }
  loadFile(file, onLoaded) {
    if (file.validationErrors?.length) {
      return;
    }
    const reader = new FileReader();
    reader.onload = ev => {
      const str = ev.target.result; // data:text/plain;base64,[CONTENT]
      onLoaded(str.substring(str.indexOf(',') + 1));
    };
    reader.readAsDataURL(file.rawFile);
  }
  onKeyUp(event) {
    if (this.form) {
      this.form.onSubmit(this, event);
    }
  }
  onKeyPress(event) {
    if (!this.pattern) {
      return;
    }
    if (!new RegExp(this.pattern).test(event.key)) {
      event.preventDefault();
    }
  }
  focusInHandler(event) {
    this.hasValue = !!this.value || !this.isDisabled;
  }
  focusOutHandler(event) {
    this.maybeApplyActive();
  }
}
AppControlComponent.ɵfac = function AppControlComponent_Factory(t) {
  return new (t || AppControlComponent)(i0.ɵɵdirectiveInject(i1.EntityManager), i0.ɵɵdirectiveInject(i0.ApplicationRef), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i3.TranslateService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i4.CodelistService), i0.ɵɵdirectiveInject(forwardRef(() => AppFormComponent), 9));
};
AppControlComponent.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
  type: AppControlComponent,
  selectors: [["app-control"]],
  viewQuery: function AppControlComponent_Query(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵviewQuery(_c0, 5);
      i0.ɵɵviewQuery(_c1, 5);
      i0.ɵɵviewQuery(FileSelectComponent, 5);
    }
    if (rf & 2) {
      let _t;
      i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tooltip = _t.first);
      i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.textarea = _t.first);
      i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.kendoFileSelect = _t.first);
    }
  },
  inputs: {
    options: "options",
    type: "type",
    label: "label",
    ngModel: "ngModel",
    modelPath: "modelPath",
    path: "path",
    entity: "entity",
    property: "property",
    codelist: "codelist",
    codelistTake: "codelistTake",
    selectLabel: "selectLabel",
    filter: "filter",
    fetch: "fetch",
    size: "size",
    multi: "multi",
    time: "time",
    format: "format",
    min: "min",
    max: "max",
    hasValue: "hasValue",
    margin: "margin",
    isDisabled: "isDisabled",
    editMode: "editMode",
    blur: "blur",
    click: "click",
    nullable: "nullable",
    textField: "textField",
    valueField: "valueField",
    popupSettings: "popupSettings",
    rows: "rows",
    fetchOnOpen: "fetchOnOpen",
    pattern: "pattern",
    maxlength: "maxlength",
    isInternalDisabled: "isInternalDisabled",
    tooltipText: "tooltipText",
    tooltipClass: "tooltipClass",
    tooltipPlacement: "tooltipPlacement",
    initialValue: "initialValue",
    decimals: "decimals",
    prepend: "prepend",
    disableTooltip: "disableTooltip",
    maxFileSize: "maxFileSize",
    allowedExtensions: "allowedExtensions",
    allowToEditFile: "allowToEditFile",
    allowToDeleteFile: "allowToDeleteFile"
  },
  features: [i0.ɵɵProvidersFeature([{
    provide: NG_VALUE_ACCESSOR,
    useExisting: AppControlComponent,
    multi: true
  }]), i0.ɵɵNgOnChangesFeature],
  ngContentSelectors: _c12,
  decls: 18,
  vars: 20,
  consts: [["class", "col-form-label", 3, "ngClass", "for", 4, "ngIf"], [4, "ngTemplateOutlet"], ["class", "k-textbox form-control form-control-sm disabled", "type", "text", "kendoTextBox", "", "placement", "top", "container", "body", "ngbTooltip", "", "tooltipClass", "error-tooltip arrow-bottom", "autocomplete", "off", 3, "ngClass", "ngModel", "ngModelChange", "keyup.enter", "focus", "blur", 4, "ngIf"], ["class", "k-textbox form-control form-control-sm", "type", "text", "kendoTextBox", "", "placement", "top", "container", "body", "ngbTooltip", "", "tooltipClass", "error-tooltip arrow-bottom", "autocomplete", "off", 3, "ngClass", "id", "maxlength", "ngModel", "ngModelChange", "keyup.enter", "keypress", "paste", "focus", "blur", 4, "ngIf"], ["class", "k-textbox form-control form-control-sm", "type", "password", "kendoTextBox", "", "placement", "top", "container", "body", "ngbTooltip", "", "tooltipClass", "error-tooltip arrow-bottom", "autocomplete", "off", 3, "ngClass", "ngModel", "ngModelChange", "keyup.enter", 4, "ngIf"], ["class", "k-textarea form-control form-control-sm", "kendoTextArea", "", "placement", "top", "container", "body", "ngbTooltip", "", "tooltipClass", "error-tooltip arrow-bottom", 3, "ngClass", "rows", "ngModel", "ngModelChange", "keyup.enter", "focus", "blur", 4, "ngIf"], ["class", "form-control form-control-sm", "placement", "top", "container", "body", "ngbTooltip", "", "tooltipClass", "error-tooltip arrow-bottom", 3, "ngClass", "maxlength", "format", "min", "max", "autoCorrect", "readonly", "ngModel", "ngModelChange", "keyup.enter", "focus", "blur", 4, "ngIf"], ["class", "form-control form-control-sm", "placement", "top", "container", "body", "ngbTooltip", "", "tooltipClass", "error-tooltip arrow-bottom", 3, "title", "ngClass", "textField", "valueField", "valuePrimitive", "data", "filterable", "clearButton", "readonly", "loading", "popupSettings", "ngModel", "ngModelChange", "keyup.enter", "focus", "blur", "open", "filterChange", 4, "ngIf"], [3, "label", "property", "size", "disabled", "click", "ngModel", "ngModelChange", "keyup.enter", 4, "ngIf"], ["style", "position: relative", 4, "ngIf"], ["class", "form-control form-control-sm", "textField", "text", "valueField", "value", "placement", "top", "container", "body", "ngbTooltip", "", "tooltipClass", "error-tooltip arrow-bottom", 3, "title", "ngClass", "valuePrimitive", "data", "filterable", "disabled", "clearButton", "ngModel", "ngModelChange", "keyup.enter", 4, "ngIf"], ["placement", "top", "container", "body", "ngbTooltip", "", "tooltipClass", "error-tooltip arrow-bottom", 3, "ngClass", "hidden", "disabled", "restrictions", "ngModel", "ngModelChange", "clear", "select", 4, "ngIf"], ["class", "k-file-multiple", "kendofileselectinternaldropzone", "", 3, "files", "editMode", "allowToEditFile", "allowToDeleteFile", "isInternalDisabled", "add", "removeFile", 4, "ngIf"], ["class", "position-relative", 4, "ngIf"], ["prependTemplate", ""], [1, "col-form-label", 3, "ngClass", "for"], ["type", "text", "kendoTextBox", "", "placement", "top", "container", "body", "ngbTooltip", "", "tooltipClass", "error-tooltip arrow-bottom", "autocomplete", "off", 1, "k-textbox", "form-control", "form-control-sm", "disabled", 3, "ngClass", "ngModel", "ngModelChange", "keyup.enter", "focus", "blur"], ["tooltip", "ngbTooltip"], ["type", "text", "kendoTextBox", "", "placement", "top", "container", "body", "ngbTooltip", "", "tooltipClass", "error-tooltip arrow-bottom", "autocomplete", "off", 1, "k-textbox", "form-control", "form-control-sm", 3, "ngClass", "id", "maxlength", "ngModel", "ngModelChange", "keyup.enter", "keypress", "paste", "focus", "blur"], ["type", "password", "kendoTextBox", "", "placement", "top", "container", "body", "ngbTooltip", "", "tooltipClass", "error-tooltip arrow-bottom", "autocomplete", "off", 1, "k-textbox", "form-control", "form-control-sm", 3, "ngClass", "ngModel", "ngModelChange", "keyup.enter"], ["kendoTextArea", "", "placement", "top", "container", "body", "ngbTooltip", "", "tooltipClass", "error-tooltip arrow-bottom", 1, "k-textarea", "form-control", "form-control-sm", 3, "ngClass", "rows", "ngModel", "ngModelChange", "keyup.enter", "focus", "blur"], ["textarea", "", "tooltip", "ngbTooltip"], ["placement", "top", "container", "body", "ngbTooltip", "", "tooltipClass", "error-tooltip arrow-bottom", 1, "form-control", "form-control-sm", 3, "ngClass", "maxlength", "format", "min", "max", "autoCorrect", "readonly", "ngModel", "ngModelChange", "keyup.enter", "focus", "blur"], ["placement", "top", "container", "body", "ngbTooltip", "", "tooltipClass", "error-tooltip arrow-bottom", 1, "form-control", "form-control-sm", 3, "title", "ngClass", "textField", "valueField", "valuePrimitive", "data", "filterable", "clearButton", "readonly", "loading", "popupSettings", "ngModel", "ngModelChange", "keyup.enter", "focus", "blur", "open", "filterChange"], [3, "label", "property", "size", "disabled", "click", "ngModel", "ngModelChange", "keyup.enter"], [2, "position", "relative"], ["class", "k-icon k-clear-value k-i-close date-time-close", 3, "click", 4, "ngIf"], ["class", "form-control form-control-sm", "placeholder", "", "ngbTooltip", "", "placement", "top", "container", "body", "tooltipClass", "error-tooltip arrow-bottom", 3, "ngClass", "readonly", "ngModel", "ngModelChange", "keyup.enter", "focus", "blur", 4, "ngIf"], [1, "k-icon", "k-clear-value", "k-i-close", "date-time-close", 3, "click"], ["placeholder", "", "ngbTooltip", "", "placement", "top", "container", "body", "tooltipClass", "error-tooltip arrow-bottom", 1, "form-control", "form-control-sm", 3, "ngClass", "readonly", "ngModel", "ngModelChange", "keyup.enter", "focus", "blur"], ["datePicker", "", "tooltip", "ngbTooltip"], ["dateTimePicker", "", "tooltip", "ngbTooltip"], ["textField", "text", "valueField", "value", "placement", "top", "container", "body", "ngbTooltip", "", "tooltipClass", "error-tooltip arrow-bottom", 1, "form-control", "form-control-sm", 3, "title", "ngClass", "valuePrimitive", "data", "filterable", "disabled", "clearButton", "ngModel", "ngModelChange", "keyup.enter"], ["placement", "top", "container", "body", "ngbTooltip", "", "tooltipClass", "error-tooltip arrow-bottom", 3, "ngClass", "hidden", "disabled", "restrictions", "ngModel", "ngModelChange", "clear", "select"], ["kendoUploadFileInfoTemplate", ""], [3, "file", "disabled", "removeFile"], ["kendofileselectinternaldropzone", "", 1, "k-file-multiple", 3, "files", "editMode", "allowToEditFile", "allowToDeleteFile", "isInternalDisabled", "add", "removeFile"], ["multiUploadTable", ""], [1, "position-relative"], ["placement", "top", "container", "body", "ngbTooltip", "", "tooltipClass", "error-tooltip arrow-bottom", 1, "form-control", "form-control-sm", 3, "title", "ngClass", "textField", "valueField", "valuePrimitive", "data", "filterable", "loading", "clearButton", "readonly", "popupSettings", "ngModel", "ngModelChange", "keyup.enter", "open", "mouseenter", "mouseleave", "focus", "blur", "filterChange"], ["kendoMultiSelectItemTemplate", ""], ["class", "multiselect-count", 4, "ngIf"], [2, "padding", "4px"], ["type", "checkbox", 1, "k-checkbox", 3, "checked"], [1, "k-checkbox-label"], [1, "multiselect-count"], ["class", "input-group-prepend", 4, "ngIf"], [1, "input-group-prepend"], [1, "input-group-text"]],
  template: function AppControlComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵprojectionDef(_c10);
      i0.ɵɵtemplate(0, AppControlComponent_label_0_Template, 2, 7, "label", 0);
      i0.ɵɵtemplate(1, AppControlComponent_ng_container_1_Template, 1, 0, "ng-container", 1);
      i0.ɵɵprojection(2);
      i0.ɵɵtemplate(3, AppControlComponent_input_3_Template, 2, 6, "input", 2);
      i0.ɵɵtemplate(4, AppControlComponent_input_4_Template, 2, 8, "input", 3);
      i0.ɵɵtemplate(5, AppControlComponent_input_5_Template, 2, 5, "input", 4);
      i0.ɵɵtemplate(6, AppControlComponent_textarea_6_Template, 3, 7, "textarea", 5);
      i0.ɵɵtemplate(7, AppControlComponent_kendo_numerictextbox_7_Template, 2, 12, "kendo-numerictextbox", 6);
      i0.ɵɵtemplate(8, AppControlComponent_kendo_combobox_8_Template, 2, 16, "kendo-combobox", 7);
      i0.ɵɵtemplate(9, AppControlComponent_app_checkbox_9_Template, 1, 6, "app-checkbox", 8);
      i0.ɵɵtemplate(10, AppControlComponent_div_10_Template, 4, 3, "div", 9);
      i0.ɵɵtemplate(11, AppControlComponent_kendo_combobox_11_Template, 2, 11, "kendo-combobox", 10);
      i0.ɵɵtemplate(12, AppControlComponent_kendo_fileselect_12_Template, 3, 8, "kendo-fileselect", 11);
      i0.ɵɵtemplate(13, AppControlComponent_app_upload_multiple_files_13_Template, 2, 5, "app-upload-multiple-files", 12);
      i0.ɵɵtemplate(14, AppControlComponent_div_14_Template, 6, 17, "div", 13);
      i0.ɵɵprojection(15, 1);
      i0.ɵɵtemplate(16, AppControlComponent_ng_template_16_Template, 1, 1, "ng-template", null, 14, i0.ɵɵtemplateRefExtractor);
    }
    if (rf & 2) {
      const _r14 = i0.ɵɵreference(17);
      i0.ɵɵproperty("ngIf", ctx.label && ctx.type !== ctx.AppControlType.Boolean && !(ctx.type === ctx.AppControlType.CodeList && ctx.multi));
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngTemplateOutlet", _r14);
      i0.ɵɵadvance(2);
      i0.ɵɵproperty("ngIf", ctx.type === ctx.AppControlType.String && ctx.isDisabled);
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.type === ctx.AppControlType.String && !ctx.isDisabled);
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.type === ctx.AppControlType.Password);
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.type === ctx.AppControlType.TextArea);
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.type === ctx.AppControlType.Number);
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", i0.ɵɵpureFunction2(14, _c11, ctx.AppControlType.Select, ctx.AppControlType.CodeList).includes(ctx.type) && !ctx.multi);
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.type === ctx.AppControlType.Boolean);
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.type === ctx.AppControlType.DateTime);
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.type === ctx.AppControlType.YesNo);
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.type === ctx.AppControlType.File);
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.type === ctx.AppControlType.File && ctx.multi);
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", i0.ɵɵpureFunction2(17, _c11, ctx.AppControlType.Select, ctx.AppControlType.CodeList).includes(ctx.type) && ctx.multi);
    }
  },
  dependencies: [i5.NgClass, i5.NgIf, i5.NgTemplateOutlet, i6.DefaultValueAccessor, i6.NgControlStatus, i6.MaxLengthValidator, i6.NgModel, i7.NgbTooltip, i8.TextAreaDirective, i8.TextBoxDirective, i8.NumericTextBoxComponent, i9.ItemTemplateDirective, i9.ComboBoxComponent, i9.MultiSelectComponent, i10.DatePickerComponent, i10.DateTimePickerComponent, i11.FileInfoTemplateDirective, i11.FileSelectComponent, i12.CheckboxComponent, i13.UploadSingleFileComponent, i14.UploadMultipleFilesComponent],
  styles: ["label[_ngcontent-%COMP%] {\n  -webkit-user-select: none;\n  \n  \n  \n  user-select: none;\n  \n}\n\n.col-form-label[_ngcontent-%COMP%] {\n  font-size: 1rem !important;\n  font-weight: 400;\n}\n\n.error-tooltip[_ngcontent-%COMP%]   .tooltip-inner[_ngcontent-%COMP%] {\n  background-color: #dc3545;\n  color: #fff;\n}\n\n.error-tooltip[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%]::before {\n  border-top-color: #dc3545;\n}\n\n.date-time-close[_ngcontent-%COMP%] {\n  position: absolute;\n  right: 31px;\n  top: 9px;\n  color: rgb(173, 173, 173);\n  z-index: 9;\n}\n.date-time-close.hidden[_ngcontent-%COMP%] {\n  visibility: hidden;\n}\n.date-time-close[_ngcontent-%COMP%]:hover {\n  color: rgb(73, 80, 87);\n}\n\n.disabled[_ngcontent-%COMP%]:not(textarea):not(kendo-fileselect) {\n  background-color: #e9ecef !important;\n}\n\n.k-multiselect-wrap[_ngcontent-%COMP%]   .k-searchbar[_ngcontent-%COMP%] {\n  float: initial;\n}\n\n.form-control-sm[_ngcontent-%COMP%]   .k-multiselect-wrap[_ngcontent-%COMP%] {\n  overflow: hidden;\n}\n\n.multiselect-count[_ngcontent-%COMP%] {\n  position: absolute;\n  top: 0.5rem;\n  right: 0;\n}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"]
});